import React from "react";
import {PlacedOrderOverview} from "@/data/entities/order";
import {FormattedMessage} from "react-intl";
import {Icon, PageHeading, PageHeadingMeta, PageHeadingMetaItem} from "peggirkit";
import {ClockIcon, ComputerDesktopIcon} from "@heroicons/react/16/solid";

type Props = {
    order: PlacedOrderOverview,
};

const OrderTitle = ({order}: Props) => {
    return (
        <PageHeading
            titleClassname={
                order.cancelledOn === null
                    ? ""
                    : "line-through !text-red-600 dark:!text-red-400"
            }
            title={
                <FormattedMessage
                    id={order.delivery ? "order-n.delivery" : "order-n.takeaway"}
                    values={{n: order.cartId}}
                />
            }
            meta={
                <PageHeadingMeta>
                    <PageHeadingMetaItem icon={<Icon icon={ClockIcon}/>}>
                        <FormattedMessage
                            id={"pos.order.placedAt"}
                            values={{time: new Date(order.creationDate).toLocaleString()}}
                        />
                    </PageHeadingMetaItem>
                    <PageHeadingMetaItem icon={<Icon icon={ComputerDesktopIcon}/>}>
                        <FormattedMessage
                            id={`orderedFromSource.${order.source}`}
                            values={{time: new Date(order.creationDate).toLocaleString()}}
                        />
                    </PageHeadingMetaItem>
                </PageHeadingMeta>
            }
        />
    );
};

export default OrderTitle;